import { Button } from "@/components/ui/button";
import { ArrowUp } from "lucide-react";

export default function () {
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <div className="fixed bottom-4 xl:bottom-8 left-4 xl:left-8">
      <Button _variant="outline" className=" rounded-full size-12" onClick={handleClick}>
        <ArrowUp />
      </Button>
    </div>
  )
}